import axios from "axios";
import { config } from "../helpers/domain-config";

export const isCreditCardProduct = config.subdomain === "portal" && config.productName!=="hkxr-a" ? true : false;

export const isImmersiLearn = config.productName === "immersi-learn";

export const isXRLab360 = config.productName === "xrlab360";

export const isTheNextGenXR = config.productName === "thenextgenxr";

export const isVirtuPaths = config.productName === "virtupaths";
export const isXRLAB = config.productName === "xr-lab";

export const UnsubscribeForCreditCard = async (email) => {
  try {
    const response = await axios.request({
      url: "https://cc.tallymans.com/api/v1/portal/unsubscribe",
      method: "POST",
      data: { email: email },
    });
    if (response.data.state === "success") {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};
